<template>
  <div ref="observerTarget">
    <slot
      v-if="isVisible"
      name="content"
    />
    <slot
      v-else
      name="placeholder"
    />
  </div>
</template>

<script>
export default {
  name: 'LazyLoadObserver',
  props: {
    // Callback to execute when widget becomes visible
    onVisible: {
      type: Function,
      required: true,
    },
    // Root margin for intersection observer (load before fully visible)
    rootMargin: {
      type: String,
      default: '100px', // Load 100px before widget enters viewport
    },
    // Only trigger once
    once: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isVisible: false,
      observer: null,
    }
  },
  mounted() {
    this.createObserver()
  },
  beforeDestroy() {
    this.destroyObserver()
  },
  methods: {
    createObserver() {
      const options = {
        root: null, // viewport
        rootMargin: this.rootMargin,
        threshold: 0.01, // Trigger when 1% of element is visible
      }

      this.observer = new IntersectionObserver(this.handleIntersect, options)

      if (this.$refs.observerTarget) {
        this.observer.observe(this.$refs.observerTarget)
      }
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isVisible) {
          this.isVisible = true

          // Execute the callback to load data
          if (this.onVisible) {
            this.onVisible()
          }

          // If once=true, stop observing after first trigger
          if (this.once && this.observer) {
            this.observer.unobserve(entry.target)
          }
        }
      })
    },
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    },
  },
}
</script>

<style scoped>
/* Ensure the container takes up space */
div {
  min-height: 100px;
}
</style>
